/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_TitleInputs */

const en_about_section3_title = /** @type {(inputs: About_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Tools`)
};

const ko_about_section3_title = /** @type {(inputs: About_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제공 도구`)
};

const ja_about_section3_title = /** @type {(inputs: About_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供ツール`)
};

/**
* | output |
* | --- |
* | "Available Tools" |
*
* @param {About_Section3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_title = /** @type {((inputs?: About_Section3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_title(inputs)
	if (locale === "ko") return ko_about_section3_title(inputs)
	return ja_about_section3_title(inputs)
});